"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var react_resizable_1 = require("react-resizable"); // Types are invalid
var react_1 = __importStar(require("react"));
var react_2 = require("@emotion/react");
var styles_1 = require("./styles");
var lodash_1 = require("lodash");
var ResizableHeader = function (_a) {
    var onResize = _a.onResize, width = _a.width, minWidth = _a.minWidth, maxWidth = _a.maxWidth, onResizeStop = _a.onResizeStop, restProps = __rest(_a, ["onResize", "width", "minWidth", "maxWidth", "onResizeStop"]);
    if (!width || !onResize) {
        return react_1.default.createElement("th", __assign({}, restProps));
    }
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(react_2.Global, { styles: styles_1.resizableStyles }),
        react_1.default.createElement(react_resizable_1.Resizable, { height: 0, axis: "x", resizeHandles: ['e'], width: width, onResizeStop: onResizeStop, onResize: onResize, minConstraints: !lodash_1.isNil(minWidth) ? [minWidth] : undefined, maxConstraints: !lodash_1.isNil(maxWidth) ? [maxWidth] : undefined },
            react_1.default.createElement("th", __assign({}, restProps)))));
};
exports.default = ResizableHeader;
